//
//
//
//
//
//
import buttonBase from './_buttonBase';
import { COOKIE_KEY_PREFIX } from '../_cookieConstants';
var favoriteButton = {
  extends: buttonBase,
  data: function data() {
    return {
      isFavorited: this.userSettings ? this.userSettings.isFavoriteItem : false,
      modelProps: this.pageAttributes || {},
      isInitialized: false
    };
  },
  computed: {
    buttonLabel: function buttonLabel() {
      return this.button ? this.isFavorited ? this.button.toggleDisplayName : this.button.displayName : '';
    }
  },
  watch: {
    button: function button() {
      // watch for props to get set before initialized - mounted works backwards for child components
      this.$_initPlaceholder();
    }
  },
  methods: {
    performAction: function performAction(isLoadedFromCookie) {
      if (!this.button) return false;

      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      if (this.userSettings.isCurrentUserAnonymous && !this.button.allowedForAnonymousUsers) {
        if (isLoadedFromCookie !== true) {
          // If the user is still anonymous and they come back to the page, ignore so they don't get redirected again.
          var key = COOKIE_KEY_PREFIX + this.toolbarName;
          this.$_setCookie(key, this.button.id);
          this.$_openRegistration();
        }

        return false;
      }

      this.$_callApi(this.isFavorited, this.modelProps.contentId);
      return !this.isFavorited; // only increment count if favorited
    },
    $_getCookieData: function $_getCookieData(key) {
      var match = document.cookie.match('(^|[^;]+)\\s*' + key + '\\s*=\\s*([^;]+)');
      var raw = match ? match.pop() : '';
      var data = decodeURI(raw) || "{}";
      return JSON.parse(data);
    },
    $_isAutoFavorite: function $_isAutoFavorite(searchParams) {
      var urlParams = new URLSearchParams(searchParams);
      return urlParams.get('AutoOpen') === 'AddToFavorites';
    },
    $_deleteCookie: function $_deleteCookie(key) {
      document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    },
    $_initPlaceholder: function $_initPlaceholder() {
      if (!this.button || this.isInitialized) return; // ensure that data items are properly set from props

      this.isFavorited = this.userSettings.isFavoriteItem;
      this.modelProps = this.pageAttributes || {};
      this.$_updateButtonClass();
      var key = COOKIE_KEY_PREFIX + this.toolbarName;
      var cookie = this.$_getCookieData(key);

      if (cookie && cookie.buttonId === this.button.id) {
        if (!this.isFavorited) {
          this.performAction(true);
        }

        this.$_deleteCookie(key);
      } else if (!this.isFavorited && this.$_isAutoFavorite(window.location.search)) {
        this.performAction();
      }

      this.isInitialized = true;
    },
    $_callApi: function $_callApi(isFavorited, contentId) {
      var _this = this;

      var addFavoriteUrl = '/api/actionToolbarFavorite/add/';
      var removeFavoriteUrl = '/api/actionToolbarFavorite/remove/';
      var url = (isFavorited ? removeFavoriteUrl : addFavoriteUrl) + contentId;
      fetch(url, {
        method: 'POST'
      }).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      }).then(function () {
        return _this.$_onSuccess();
      }).catch(function () {
        return _this.$_onError();
      });
    },
    $_onSuccess: function $_onSuccess() {
      this.isFavorited = !this.isFavorited;
      this.$_updateButtonClass(); // TODO send event to update other buttons??

      if (this.isFavorited && window.utag_data) {
        var analyticsEventParams = {
          ContentId: window.utag_data.ContentId,
          ContentTitle: window.utag_data.ContentTitle,
          ContentType: window.utag_data.ContentType,
          RecordType: window.utag_data.RecordType
        };
        this.$_raiseAnalyticsEvent('AddToFavorites', analyticsEventParams);
      }
    },
    $_onError: function $_onError() {
      var wasFavorite = this.isFavorited;
      var tryingToAdd = !wasFavorite,
          message = tryingToAdd ? this.button.addFavoriteErrorMessage : this.button.removeFavoriteErrorMessage;
      this.$_showMessage(message);
    },
    $_showMessage: function $_showMessage(messageText) {
      var messageSettings = {
        message: messageText
      };
      this.$emit('set-modal', 'messageModal', messageSettings);
    },
    $_openRegistration: function $_openRegistration() {
      var eSourceCodeParam = '&esrc=';
      var regActionParam = '?regAction=';
      var regFirstStepParam = '&isRegistrationFirstStep=';
      var returnUrlParam = '&returnUrl=';
      var valuePropParam = '&value_prop=AnonFavorites';
      var regUrl = this.modelProps.registrationUrl || '/user-profile/login';
      var regSettings = {
        returnUrl: window.location,
        isAuthenticated: false,
        isRegistrationFirstStep: false,
        isScreenNameSet: false,
        regAction: this.button.regAction,
        eSourceCode: this.button.eSourceCode
      };
      var url = [regUrl, regActionParam + regSettings.regAction, eSourceCodeParam + regSettings.eSourceCode, regFirstStepParam + regSettings.isRegistrationFirstStep, returnUrlParam + encodeURIComponent(regSettings.returnUrl)];

      if (this.userSettings.isAnonymousUserWithFavorites) {
        url.push(valuePropParam);
      }

      this.$_redirect(url.join(""));
    },
    $_setCookie: function $_setCookie(key, buttonId) {
      document.cookie = key + '=' + encodeURI(JSON.stringify({
        buttonId: buttonId
      }));
    },
    $_redirect: function $_redirect(url) {
      window.location = url;
    },
    $_updateButtonClass: function $_updateButtonClass() {
      var className = this.isFavorited ? 'favorited' : null;
      this.$emit('set-button-class', this.button.id, className);
    }
  }
};
export default favoriteButton;